import { showMessage } from "app/store/App/message.slice";
import { getApiErrorMessage } from "app/utils/getApiErrorMessage";

const msgConfig = {
  autoHideDuration: 6000,
  anchorOrigin: {
    vertical: "top" as const,
    horizontal: "right" as const,
  },
};

type MsgInput = string | unknown;

export const errorMsg = (msgOrError: MsgInput, fallback = "Something went wrong") => {
  const message =
    typeof msgOrError === "string"
      ? msgOrError
      : getApiErrorMessage(msgOrError, fallback);

  return showMessage({
    message,
    variant: "error",
    ...msgConfig,
  });
};

export const successMsg = (msg: string) => {
  return showMessage({
    message: msg,
    variant: "success",
    ...msgConfig,
  });
};

export const warningMsg = (msg: string) => {
  return showMessage({
    message: msg,
    variant: "warning",
    ...msgConfig,
  });
};

export const infoMsg = (msg: string) => {
  return showMessage({
    message: msg,
    variant: "info",
    ...msgConfig,
  });
};
